export default "__VITE_ASSET__Ce92IvIJ__"